
interface FooterMenuProps {
  footerMenu?: {
    title?: string;
    menuItem?: {
      label?: string;
      link?: string;
    }[];
  }[];
}
export const FooterMenu  = ({ footerMenu }: FooterMenuProps) => {
  return (
    <nav className="container  border-t border-b grid grid-cols-2 gap-x-6 gap-y-10 py-14 md:grid-cols-3 xl:grid-cols-6 ">
      {footerMenu?.map((section) => (
        <div key={section.title}>
          <h3 className="mb-4 paragraph-sm font-bold text-foreground">{section.title}</h3>
          <ul className="space-y-2">
            {section.menuItem?.map((link) => (
              <li key={link.label}>
                <a
                  href={link.link}
                  className="inline-block paragraph-sm text-muted-foreground"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
};